<template lang='pug'>
div(class='html' v-html='html')
</template>

<script>
export default {
  props: ['html']
}
</script>
